/**
 * 种养殖大类
 */
export enum PlantingBigType {
  CropFarming = 1, // 种植业
  AnimalHusbandry = 2, // 畜牧业（陆上养殖）
  AquaticProducts = 3, // 水产品 （水产养殖）
}
